import { Injectable } from '@angular/core';

import { AbstractRequestFormAdaptor } from '../../form/abstract-request-form.adaptor';

@Injectable()
export abstract class AbstractLoginAdaptor<FormData, Res> extends AbstractRequestFormAdaptor<FormData, Res> {
  override name = 'login';
}
